// Whitelist for the Shape noise-filter toggle (Task 1610). Keep in sync with
// the backend's shape whitelist once BE Task 1614 lands.
export const SHAPE_WHITELIST = [
  "Round",
  "Oval",
  "Radiant",
  "Emerald",
  "Marquise",
  "Cushion",
  "Pear",
  "Princess",
  "Asscher",
  "Heart",
];

export const isValidShape = (label) =>
  SHAPE_WHITELIST.some(
    (shape) => shape.toLowerCase() === String(label ?? "").trim().toLowerCase()
  );
